module.exports = __webpack_public_path__ + "img/ertiga-xl7Form.d6da4814.svg";